var remote = inElectron() ? require('electron').remote : false;

(function ($, Promise) {

        // Setup the prototype inheritance
        extend(BaseGame, BaseGamePAC);

        // Constructor
        function BaseGamePAC(dataFile) {

            this.settingsFile = 'settings.json';
            this.dataFile = dataFile;
            this.burningScreenInterval = false;

            this.tilteDestination = {
                x: 0,
                y: -100,
                scale: 0.45,
            }

            this.titleTimeline = false;
            this.stillThereTimeout = false;
            this.stillThereInterval = false;

            // Super constructor
            BaseGame.call(this);

            // Close still there
            $(document).on(this.touchEvent, "#still-there", $.proxy(function (e) {
                if ($(e.currentTarget).hasClass("active")) {
                    this.closeStillThereModal();
                }
            }, this))

            // Wait for all
            Promise.all([
                // Load settings.json
                this.loadSettings(),
            ]).then($.proxy(function () {
                // Load data.json
                return this.loadData();
            }, this)).then($.proxy(function () {
                // Build nunjucks content
                return this.renderNunjucks();
            }, this)).then($.proxy(function () {
                // Build content
                return this.buildDOM();
            }, this)).then($.proxy(function () {
                // Replace strings {{ }}
                // return this.replaceWithData();
            }, this)).then($.proxy(function () {
                // Real game init
                return this.initGame();
            }, this)).then($.proxy(function () {
                // Set language
                this.i18n.set("fr");
            }, this));

        }

        // Load settings JSON (with promise)
        BaseGamePAC.prototype.loadSettings = function () {
            return new Promise($.proxy(function (resolve, reject) {

                $.getJSON(this.settingsFile).done($.proxy(function (data) {
                    this.settings = data;

                    // Init screensaver
                    if (typeof this.settings.screensaver_delay != "undefined") {
                        this.screensaverDelay = this.settings.screensaver_delay;
                    }
                    // Remove arduino simulator if requested
                    if (typeof this.settings.arduino_simulator != "undefined" && this.settings.arduino_simulator == false) {
                        $(".arduino-simulator, #printed-guide").remove();
                    }

                    resolve();

                }, this)).fail(function () {
                    alert("The settings.json file was not found. Please add the setting file and restart app.");
                    if (remote) {
                        remote.app.quit();
                    }

                    reject();
                });
            }, this));
        };

        // Load data JSON (with promise)
        BaseGamePAC.prototype.loadData = function () {
            return new Promise($.proxy(function (resolve, reject) {
                $.getJSON(this.dataFile).done($.proxy(function (data) {
                    this.data = data;
                    resolve();
                }, this)).fail(function () {
                    alert("No data found. Please add the data file and restart the app.");
                    reject();
                });
            }, this));
        };

        // Render twig style with nunjucks
        BaseGamePAC.prototype.renderNunjucks = function () {
            return new Promise($.proxy(function (resolve, reject) {

                nunjucks.configure('', {
                    autoescape: false,
                });
                var res = nunjucks.renderString($("#main").html(), {data: this.data, app: this});
                $("#main").html(res)

                $("img").each(function (i, img) {
                    if ($(img).data("src")) {
                        $(img).attr("src", $(img).data("src"))
                    }
                });

                resolve();
            }, this));
        }

        // To be overriden in child games
        BaseGamePAC.prototype.buildDOM = function () {
            return new Promise($.proxy(function (resolve, reject) {
                resolve();
            }, this));
        }

        // To be overriden in child games
        BaseGamePAC.prototype.initGame = function () {
            this.startBurningScreenProtection();
            this.initScreenSaver();
            this.goToScreen(1);
        };

        // To be overriden in child games
        BaseGamePAC.prototype.initScreen = function (screenId) {

            // Super constructor
            if (BaseGame.prototype.initScreen.call(this, screenId) == false) {
                return false;
            }

            if (this.initalScreenInterval != false) {
                clearInterval(this.initalScreenInterval);
                this.initalScreenInterval = false;
            }

            if (this.requestedLanguage != false) {
                this.i18n.set(this.requestedLanguage);
                this.requestedLanguage = false;
            }

            switch (screenId) {
                case 1:
                    this.startBurningScreenProtection();
                    break;
                default:
                    this.stopBurningScreenProtection();
            }
        }

        BaseGamePAC.prototype.placeTitle = function (titleMode, textMode) {

            if (titleMode == this.currentTitleMode && textMode == this.currentTitleTextMode) {
                return;
            }

            if (this.titleTimeline) {
                this.titleTimeline.kill();
                this.titleTimeline = false;
            }

            this.titleTimeline = new TimelineMax();

            if (textMode == "hide" && this.currentTitleTextMode != "hide" && $("#game-title .description").length > 0) {
                this.titleTimeline.to($("#game-title .description"), 0.45, {
                    opacity: 0,
                    ease: this.defaultEasing,
                    y: -20,
                    force3D:true,
                });
            }

            if (titleMode == "small" && this.currentTitleMode != "small") {
                this.titleTimeline.to($("#game-title"), 0.95, {
                    x: this.tilteDestination.x,
                    y: this.tilteDestination.y,
                    force3D:true,
                    scale: this.tilteDestination.scale,
                    transformOrigin: "left top",
                    ease: this.defaultEasing,
                });
                this.titleTimeline.to($("#game-title .subtitle"), 0.45, {
                    y: -20,
                    force3D:true,
                    autoAlpha: 0,
                    ease: this.defaultEasing,
                }, 0.30);

            } else if (titleMode == "big" && this.currentTitleMode != "big") {
                this.titleTimeline.to($("#game-title .subtitle"), 0.45, {
                    y: 0,
                    force3D:true,
                    autoAlpha: 1,
                    ease: this.defaultEasing,
                });
                this.titleTimeline.to($("#game-title"), 0.95, {
                    x: 0,
                    y: 0,
                    force3D:true,
                    scale: 1,
                    transformOrigin: "left top",
                    ease: this.defaultEasing,
                }, 0.45);
            }

            if (textMode == "show" && this.currentTitleTextMode != "show" && $("#game-title .description").length > 0) {
                this.titleTimeline.fromTo($("#game-title .description"), 0.45, {
                    y: -100,
                }, {
                    y: 0,
                    force3D:true,
                    opacity: 1,
                    ease: this.defaultEasing,
                });
            }

            this.currentTitleMode = titleMode;
            this.currentTitleTextMode = textMode;
        }

        BaseGamePAC.prototype.toggleLanguageButton = function (toggleValue) {
            TweenMax.to($("#language-switcher"), 0.45, {
                opacity: (toggleValue ? 1 : 0),
            });
        }

        BaseGamePAC.prototype.goToScreenSaver = function () {

            if ($("#still-there").hasClass("active")) {
                return false;
            }

            var $counter = $("#still-there .still-there-counter .number");
            var duration = 10000;

            $("#still-there").addClass("active");
            $("#still-there .still-there-counter .number").text(Math.floor(duration / 1000))
            $counter.data("count", Math.floor(duration / 1000) + 1);

            this.openStillThereModal();
            this.stillThereTimeout = setTimeout($.proxy(function () {
                // this.goToScreen(1);
                this.goToScreen(1, $.proxy(this.reset, this));
                this.closeStillThereModal();
            }, this), (duration + 2200));

            this.stillThereInterval = setInterval($.proxy(function () {
                var currentValue = $counter.data("count");
                $("#still-there .still-there-counter .number").text(Math.max(0, currentValue - 1));
                $counter.data("count", currentValue - 1)
            }, this), 1000);
        }


        BaseGamePAC.prototype.openStillThereModal = function () {
            var tl = new TimelineMax();

            tl.to($("#still-there"), 0.5, {
                autoAlpha: 1,
            });

            tl.fromTo($("#still-there .modal"), 1.2, {
                y: "180px",
            }, {
                y: "0px",
            });
        }

        BaseGamePAC.prototype.closeStillThereModal = function () {

            if (this.stillThereTimeout != false) {
                clearTimeout(this.stillThereTimeout);
                this.stillThereTimeout = false;
            }

            if (this.stillThereInterval != false) {
                clearInterval(this.stillThereInterval);
                this.stillThereInterval = false;
            }

            TweenMax.to($("#still-there"), 0.5, {
                autoAlpha: 0,
                onComplete: function () {
                    $("#still-there").removeClass("active");
                }
            });

            TweenMax.to($("#still-there  .modal"), 0.5, {
                y: "50px",
                onComplete: function () {
                    $("#still-there").removeClass("active");
                }
            });
        }

        BaseGamePAC.prototype.startBurningScreenProtection = function () {
            this.stopBurningScreenProtection();
            var intervalDuration = parseInt(this.settings["burning_screen_interval"]) * 1000;
            this.burningScreenInterval = requestInterval($.proxy(function () {
                var tl = new TimelineMax();
                tl.to($("#burning-protect"), 0.1, {
                    autoAlpha: 1,
                    ease: Linear.easeNone
                }, 0);
                tl.fromTo($("#burning-protect"), 3.5, {
                    y: 0,
                    ease: Linear.easeNone
                }, {
                    y: 1080 + 100,
                    ease: Linear.easeNone
                }, 0);
                tl.to($("#burning-protect"), 0.2, {
                    autoAlpha: 0,
                    ease: Linear.easeNone
                }, "-=0.2");
            }, this), intervalDuration)
        }

        BaseGamePAC.prototype.stopBurningScreenProtection = function () {
            if (this.burningScreenInterval != false) {
                clearRequestInterval(this.burningScreenInterval);
                this.burningScreenInterval = false;
            }
        }

        BaseGamePAC.prototype.findAllAudioFiles = function (objectToParse) {
            return this.findAllExtensionFilesInObject(objectToParse, [".mp3", ".wav"]);
        }


        // Reset values when we return to the homepage
        BaseGamePAC.prototype.reset = function (screenId) {


            if (typeof screenId == "undefined") {
                screenId = 1;
            }

            if (BaseGame.prototype.reset.call(this) == false) {
                return false;
            }

            if (this.stillThereTimeout != false) {
                clearTimeout(this.stillThereTimeout);
                this.stillThereTimeout = false;
            }

            if (this.stillThereInterval != false) {
                clearInterval(this.stillThereInterval);
                this.stillThereInterval = false;
            }

            // Reset language
            if (this.i18n.lang == "en") {
                this.i18n.flip();
            }

        };

        // Expose BaseGamePAC
        window.BaseGamePAC = BaseGamePAC;
    }
)
(jQuery, Promise);
